import { render } from "./FinancialManagementSection.vue?vue&type=template&id=33ad09b8&scoped=true"
import script from "./FinancialManagementSection.vue?vue&type=script&lang=js"
export * from "./FinancialManagementSection.vue?vue&type=script&lang=js"

import "./FinancialManagementSection.vue?vue&type=style&index=0&id=33ad09b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ad09b8"]])

export default __exports__